// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","Loading":"App_Loading__GRbSu","Loaded":"App_Loaded__7gmuk","BackgroundFooterImage":"App_BackgroundFooterImage__wkld2"};